import { createMapboxImageUrl as createMapboxImageUrlHelper } from '../helper'

export default {
  methods: {
    loadImage(link) {
      const vm = this
      return new Promise(function(resolve, reject) {
        vm.map.loadImage(link, function(error, image) {
          if (error) reject(error)
          else resolve(image)
        })
      })
    },
    async createMapboxImageUrl(id, link, option) {
      return createMapboxImageUrlHelper(this.map.id, id, link, option)
    },
    async createMapboxImage(id, link) {
      if (!this.map.hasImage(id)) {
        this.map.addImage(id, await this.createHTMLImageElement(link))
      }

      return id
    },

    createHTMLImageElement(link) {
      return new Promise(function(resolve, reject) {
        const img = document.createElement('img')
        img.src = link
        img.width = 24
        img.height = 24

        img.onload = () => resolve(img)
        img.onerror = reject
      })
    },
  },
}
